import { useContext, useMemo } from 'react';

import { LoggerReactContext } from './context';
import { LoggerNodeInfo, LoggerNodeInfoOverride } from './types';

export function useLogger(nodeInfo: LoggerNodeInfo | string, overrideNodeInfo?: LoggerNodeInfoOverride | string) {
    const { useLogger: useLoggerImplementation } = useContext(LoggerReactContext);

    const parsedNodeInfo = useMemo(() => normalizeNode(nodeInfo), [nodeInfo]);
    const parsedOverrideNodeInfo = useMemo(
        () => (overrideNodeInfo ? normalizeNode(overrideNodeInfo) : undefined),
        [overrideNodeInfo]
    );

    return useLoggerImplementation(parsedNodeInfo, parsedOverrideNodeInfo);
}

function normalizeNode<T extends { name?: string }>(nodeInfo: T | string) {
    if (typeof nodeInfo === 'string') {
        return { name: nodeInfo };
    }

    return nodeInfo;
}
